module.exports = __webpack_public_path__ + "img/cca5f5e.svg";